import { useState } from 'react';
import axios from 'axios';
import Input from './Input';
import TextArea from './TextArea';
import Button from '../Button';
import './Form.css';

function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [status, setStatus] = useState({
    loading: false,
    success: false,
    error: null
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: false, error: null });

    try {
      const response = await axios.post('https://jobs-opportunity-backend.vercel.app/api/contact', formData);
      
      if (response.data.success) {
        setStatus({ loading: false, success: true, error: null });
        // Clear form after successful submission
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
      } else {
        setStatus({ loading: false, success: false, error: response.data.message || 'Failed to send message' });
      }
    } catch (error) {
      setStatus({
        loading: false,
        success: false,
        error: error.response?.data?.message || 'Failed to send message. Please try again.'
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="contact-form-container">
      <h2>Send us a Message</h2>
      {status.success && (
        <div className="success-message">
          Thank you for your message! We'll get back to you soon.
        </div>
      )}
      {status.error && (
        <div className="error-message">
          {status.error}
        </div>
      )}
      <form onSubmit={handleSubmit} className="contact-form">
        <Input
          label="Full Name"
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          placeholder="Enter your full name"
          disabled={status.loading}
        />

        <Input
          label="Email Address"
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
          placeholder="Enter your email address"
          disabled={status.loading}
        />

        <Input
          label="Subject"
          type="text"
          id="subject"
          name="subject"
          value={formData.subject}
          onChange={handleChange}
          required
          placeholder="Enter message subject"
          disabled={status.loading}
        />

        <TextArea
          label="Message"
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
          placeholder="Enter your message"
          rows="5"
          disabled={status.loading}
        />

        <Button type="submit" variant="primary" disabled={status.loading}>
          {status.loading ? 'Sending...' : 'Send Message'}
        </Button>
      </form>
    </div>
  );
}

export default ContactForm; 